.dragging {
  .item:hover {
    background: initial;
  }
}
